import { Component, OnInit, ViewChild } from '@angular/core';
import { NavMenuService } from '../../../shared/services/nav-menu-service';
import { RecAlphaSearchGridComponent } from '../../components/rec-alpha-search-grid/rec-alpha-search-grid.component';
import { Store } from '@ngrx/store';
import * as NameActions from './../../../store/actions/name.action';
import * as RoleActions from './../../../store/actions/role.action';
import * as ContainsActions from './../../../store/actions/contains.action';
import * as DateRangeActions from './../../../store/actions/daterange.action';
import * as CityActions from './../../../store/actions/citytown.action';
import * as DocTypeActions from './../../../store/actions/doctype.action';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';
import { Router } from '@angular/router';

@Component({
  selector: 'app-rec-alpha-result-pg',
  templateUrl: './rec-alpha-result-pg.component.html',
  styleUrls: ['./rec-alpha-result-pg.component.css']
})



export class RecAlphaResultPgComponent implements OnInit {

  @ViewChild(RecAlphaSearchGridComponent, { static: true }) recAlphaSearchResults;
  public userInput: any;
  public roleId: number;
  public contains: number;

  constructor(public nav: NavMenuService, private store: Store<AppState>, private router: Router) {

    store.select(getRegSearchState).subscribe(data => this.userInput = data);
    this.roleId = +this.userInput.role.role[1].roleID;
    //this.contains = this.userInput.contains[0].contains;
    console.log('alpha result ' + this.userInput.name.name[1].lastcorpName + ' ' + this.userInput.name.name[1].fName + ' ' + this.roleId + ' ' + this.roleId)
  }

  ngOnInit() {
    this.nav.hide();
  }

  //delRecFromStore(index) {
  //  //this.store.dispatch(new RecActions.RemoveRec(index));
  //  this.store.dispatch(new NameActions.RemoveName(index));
  //  this.store.dispatch(new RoleActions.RemoveRole(index));
  //  this.store.dispatch(new ContainsActions.RemoveContains(index));
  //  this.store.dispatch(new DateRangeActions.RemoveDate(index));
  //  this.store.dispatch(new CityActions.RemoveCity(index));
  //  this.store.dispatch(new DocTypeActions.RemoveDoct(index));
  //}

  //launch name search for selected row
  search(last_name, first_name) {

    //console.log('alpha search result pg ' + this.roleId);

    //this.delRecFromStore(0);

    //this.addRecToStore(
    //  first_name,
    //  last_name,
    //  this.roleId, //this.roleChild.utilityobj.roleID,
    //  0, //this.containsChild.utilityobj.contains,
    //  '', //this.compoundNameChild2.utilityobj.fName2,
    //  '', //this.compoundNameChild2.utilityobj.lastcorpName2,
    //  0, //this.roleChild2.utilityobj.roleID2,
    //  '1/1/1962', //this.dateRangeChild.utilityobj.fromDate,
    //  '12/31/2021', //this.dateRangeChild.utilityobj.toDate,
    //  '', //this.cityTownChild.utilityobj.citytowns,
    //  '');  //this.docTypeChild.utilityobj.doctypes);


    ////    const target = url + '/' + this.compoundNameChild.utilityobj.lastcorpName + '/' + this.compoundNameChild.utilityobj.fName;
    ////    window.open(url, "_blank")
    //this.router.navigate(['/rec-name-search-result-pg']);

  }

  //addRecToStore(fname, lname, role, Contains, fname2, lname2, role2, fromdate, todate, citytowns, doctypes) {

  //  this.store.dispatch(new NameActions.AddName({
  //    fName: fname,
  //    lastcorpName: lname
  //  }));

  //  this.store.dispatch(new RoleActions.AddRole({
  //    roleID: role
  //  }));

  //  console.log('Contains - ' + Contains);

  //  this.store.dispatch(new ContainsActions.AddContains({
  //    contains: Contains
  //  }));

  //  this.store.dispatch(new DateRangeActions.AddDate({
  //    fromDate: fromdate,
  //    toDate: todate
  //  }));

  //  this.store.dispatch(new CityActions.AddCity({
  //    citytowns: citytowns
  //  }));

  //  this.store.dispatch(new DocTypeActions.AddDoct({
  //    doctypes: doctypes
  //  }));
  //}



}
